import {
  AUTH_REQUEST,
  AUTH_DONE,
  GETTING_RESTAURANTS,
  RESTAURANTS_LOADED,
  SHOW_READY_MODAL,
  SET_LOADER,
  SET_LOADING_MENUS,
  SET_SUGGESTING,
  PARTNER_OPERATION_LOADING,
  SUBMITTING_FORM,
  INVITE_OPERATION_LOADING,
  ACCEPTING_INVITE,
  REJECTING_INVITE,
  PLACING_ORDER,
  SAVING_ADDRESS,
  LOADING_MODAL_ACTION,
} from "../types/types"
/*Non-persistent reducer for loading states*/
const initialState = {
  isAuthenticating: false,
  fetchingRestaurantData: false,
  showReadyModal: false,
  itemOperationLoading: null,
  loadingMenus: null,
  inviteOperationLoading: false,
  acceptingInvite: false,
  rejectingInvite: false,
  partnerOperationLoading: false,
  submittingForm: false,
  suggesting: false,
  placingOrder: false,
  savingAddress: false,
  loadingModalAction: false,
}
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case AUTH_REQUEST:
      return {
        ...state,
        isAuthenticating: true,
      }
    case AUTH_DONE:
      return {
        ...state,
        isAuthenticating: false,
      }
    case GETTING_RESTAURANTS:
      return {
        ...state,
        fetchingRestaurantData: true,
      }
    case RESTAURANTS_LOADED:
      return {
        ...state,
        fetchingRestaurantData: false,
      }
    case SHOW_READY_MODAL:
      return {
        ...state,
        showReadyModal: payload,
      }
    case SET_LOADER:
      return {
        ...state,
        itemOperationLoading: payload,
      }
    case SET_LOADING_MENUS:
      return {
        ...state,
        loadingMenus: payload,
      }
    case SET_SUGGESTING:
      return {
        ...state,
        suggesting: payload,
      }
    case PARTNER_OPERATION_LOADING:
      return {
        ...state,
        partnerOperationLoading: payload,
      }
    case SUBMITTING_FORM:
      return {
        ...state,
        submittingForm: payload,
      }
    case INVITE_OPERATION_LOADING:
      return {
        ...state,
        inviteOperationLoading: payload,
      }
    case ACCEPTING_INVITE:
      return {
        ...state,
        acceptingInvite: payload,
      }
    case REJECTING_INVITE:
      return {
        ...state,
        rejectingInvite: payload,
      }
    case PLACING_ORDER:
      return {
        ...state,
        placingOrder: payload,
      }
    case SAVING_ADDRESS:
      return {
        ...state,
        savingAddress: payload,
      }
    case LOADING_MODAL_ACTION:
      return {
        ...state,
        loadingModalAction: payload,
      }
    default:
      return state
  }
}
